"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMintingFees = exports.getCollateralRequiredForComboOption = exports.getPhysicalExerciseMultiplier = exports.getTokenAmountToExercise = exports.getMinLotSize = exports.getOptionMintDecimals = exports.getUserOptionMintTokenAccountAddress = exports.getBidVaultAddress = exports.getBidAccountAddress = exports.getAuctionVaultAddress = exports.getAuctionAddress = exports.getVaultAddress = exports.getCreatorTokenAccountAddress = exports.getOptionMintAddress = exports.getOptionAccountAddress = exports.getSettlementAddress = exports.getWhitelistFeesAccountAddress = exports.getUnderlyingAddress = exports.getVaultAuthorityAddress = exports.getMintAuthorityAddress = exports.getStateAddress = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const web3_js_1 = require("@solana/web3.js");
const constants = __importStar(require("./constants"));
const spl_token_1 = require("@solana/spl-token");
const types = __importStar(require("./types"));
const flex_1 = require("./flex");
function getStateAddress(programId) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(anchor.utils.bytes.utf8.encode("state"))], programId);
}
exports.getStateAddress = getStateAddress;
function getMintAuthorityAddress(programId) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(anchor.utils.bytes.utf8.encode("mint-auth"))], programId);
}
exports.getMintAuthorityAddress = getMintAuthorityAddress;
function getVaultAuthorityAddress(programId) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(anchor.utils.bytes.utf8.encode("vault-auth"))], programId);
}
exports.getVaultAuthorityAddress = getVaultAuthorityAddress;
function getUnderlyingAddress(programId, mint) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("underlying")),
        mint.toBuffer(),
    ], programId);
}
exports.getUnderlyingAddress = getUnderlyingAddress;
function getWhitelistFeesAccountAddress(programId, user) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("whitelist-fees")),
        user.toBuffer(),
    ], programId);
}
exports.getWhitelistFeesAccountAddress = getWhitelistFeesAccountAddress;
function getSettlementAddress(programId, underlying, settlementTs) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("settlement")),
        underlying.toBuffer(),
        settlementTs.toArrayLike(Buffer, "le", 8),
    ], programId);
}
exports.getSettlementAddress = getSettlementAddress;
function getOptionAccountAddress(programId, underlying, underlyingCount) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("option-account")),
        underlying.toBuffer(),
        underlyingCount.toArrayLike(Buffer, "le", 8),
    ], programId);
}
exports.getOptionAccountAddress = getOptionAccountAddress;
function getOptionMintAddress(programId, optionAccount) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("option-mint")),
        optionAccount.toBuffer(),
    ], programId);
}
exports.getOptionMintAddress = getOptionMintAddress;
function getCreatorTokenAccountAddress(programId, optionMint, creator) {
    return web3_js_1.PublicKey.findProgramAddressSync([optionMint.toBuffer(), creator.toBuffer()], programId);
}
exports.getCreatorTokenAccountAddress = getCreatorTokenAccountAddress;
function getVaultAddress(programId, optionAccount, nonce) {
    if (nonce !== undefined) {
        return [
            web3_js_1.PublicKey.createProgramAddressSync([
                Buffer.from(anchor.utils.bytes.utf8.encode("vault")),
                optionAccount.toBuffer(),
                Buffer.from([nonce]),
            ], programId),
            undefined,
        ];
    }
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("vault")),
        optionAccount.toBuffer(),
    ], programId);
}
exports.getVaultAddress = getVaultAddress;
function getAuctionAddress(programId, auctionTokenMint, creator, amount, bidEnd, cooldownEnd) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("auction")),
        auctionTokenMint.toBuffer(),
        creator.toBuffer(),
        amount.toArrayLike(Buffer, "le", 8),
        bidEnd.toArrayLike(Buffer, "le", 8),
        cooldownEnd.toArrayLike(Buffer, "le", 8),
    ], programId);
}
exports.getAuctionAddress = getAuctionAddress;
function getAuctionVaultAddress(programId, auctionTokenMint, creator, amount, bidEnd, cooldownEnd, nonce) {
    if (nonce !== undefined) {
        return [
            web3_js_1.PublicKey.createProgramAddressSync([
                Buffer.from(anchor.utils.bytes.utf8.encode("auction-vault")),
                auctionTokenMint.toBuffer(),
                creator.toBuffer(),
                amount.toArrayLike(Buffer, "le", 8),
                bidEnd.toArrayLike(Buffer, "le", 8),
                cooldownEnd.toArrayLike(Buffer, "le", 8),
                Buffer.from([nonce]),
            ], programId),
            undefined,
        ];
    }
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("auction-vault")),
        auctionTokenMint.toBuffer(),
        creator.toBuffer(),
        amount.toArrayLike(Buffer, "le", 8),
        bidEnd.toArrayLike(Buffer, "le", 8),
        cooldownEnd.toArrayLike(Buffer, "le", 8),
    ], programId);
}
exports.getAuctionVaultAddress = getAuctionVaultAddress;
function getBidAccountAddress(programId, auctionAccount, bidder) {
    return anchor.web3.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("bid-account")),
        auctionAccount.toBuffer(),
        bidder.toBuffer(),
    ], programId);
}
exports.getBidAccountAddress = getBidAccountAddress;
function getBidVaultAddress(programId, auctionAccount, bidder) {
    return anchor.web3.PublicKey.findProgramAddressSync([
        Buffer.from(anchor.utils.bytes.utf8.encode("bid-vault")),
        auctionAccount.toBuffer(),
        bidder.toBuffer(),
    ], programId);
}
exports.getBidVaultAddress = getBidVaultAddress;
function getUserOptionMintTokenAccountAddress(programId, optionMint, user) {
    return anchor.web3.PublicKey.findProgramAddressSync([optionMint.toBuffer(), user.toBuffer()], programId);
}
exports.getUserOptionMintTokenAccountAddress = getUserOptionMintTokenAccountAddress;
function getOptionMintDecimals(mintDecimals) {
    return Math.max(0, mintDecimals - constants.OPTION_DECIMAL_ADJUSTMENT);
}
exports.getOptionMintDecimals = getOptionMintDecimals;
function getMinLotSize(mintDecimals) {
    return 10 ** mintDecimals / 10 ** getOptionMintDecimals(mintDecimals);
}
exports.getMinLotSize = getMinLotSize;
async function getTokenAmountToExercise(connection, optionInfo, userTokenAccounts, exerciseAmount) {
    let totalOptionAmount = 0;
    if (exerciseAmount == undefined) {
        for (let i = 0; i < userTokenAccounts.length; i++) {
            if (userTokenAccounts[i].mint.equals(optionInfo.optionMint)) {
                totalOptionAmount += Number(userTokenAccounts[i].amount);
            }
        }
    }
    else {
        totalOptionAmount = exerciseAmount;
    }
    let multiplier = await getPhysicalExerciseMultiplier(optionInfo.kind, optionInfo.strike.toNumber(), optionInfo.exerciseMint, optionInfo.optionMint, connection);
    return Math.floor(Number(totalOptionAmount) * multiplier);
}
exports.getTokenAmountToExercise = getTokenAmountToExercise;
async function getPhysicalExerciseMultiplier(kind, strike, exerciseMint, optionMint, connection) {
    if (kind == types.Kind.CALL) {
        return (strike / Math.pow(10, (await (0, spl_token_1.getMint)(connection, optionMint)).decimals));
    }
    else if (kind == types.Kind.PUT) {
        return (Math.pow(10, constants.OPTION_DECIMAL_ADJUSTMENT +
            (await (0, spl_token_1.getMint)(connection, exerciseMint)).decimals) / strike);
    }
    else {
        throw Error("Invalid option kind for an exercise mint");
    }
}
exports.getPhysicalExerciseMultiplier = getPhysicalExerciseMultiplier;
function sortedIndex(array, value) {
    var low = 0, high = array.length;
    while (low < high) {
        var mid = (low + high) >>> 1;
        if (array[mid] < value)
            low = mid + 1;
        else
            high = mid;
    }
    return low;
}
function calculateSignedCostOfTrades(price, size) {
    return (price * size) / Math.pow(10, constants.COMBO_SIZE_PRECISION);
}
function getCollateralRequiredForComboOption(optionParams) {
    // Get strikes, call_sizes, put_sizes
    if (optionParams.length > constants.MAX_COMBO_OPTION_LEGS) {
        throw Error("Too many sets of option parameters to mint this combo option");
    }
    let strikes = [0];
    let callSizes = [0];
    let putSizes = [0];
    for (let i = 0; i < optionParams.length; i++) {
        let pos = sortedIndex(strikes, optionParams[i].strike);
        strikes.splice(pos, 0, optionParams[i].strike);
        if (optionParams[i].kind == types.Kind.CALL) {
            callSizes.splice(pos, 0, optionParams[i].size);
            putSizes.splice(pos, 0, 0);
        }
        else if (optionParams[i].kind == types.Kind.PUT) {
            callSizes.splice(pos, 0, 0);
            putSizes.splice(pos, 0, optionParams[i].size);
        }
        else {
            callSizes.splice(pos, 0, 0);
            putSizes.splice(pos, 0, 0);
        }
    }
    // get call cum pnl
    let callCumPnl = Array(optionParams.length + 1).fill(0);
    let callCumPositions = Array(optionParams.length + 1).fill(0);
    for (let i = 1; i < optionParams.length + 1; i++) {
        callCumPositions[i] = callSizes[i] + callCumPositions[i - 1];
        let strikeDiff = strikes[i] - strikes[i - 1];
        let pnlDelta = calculateSignedCostOfTrades(strikeDiff, callCumPositions[i - 1]);
        callCumPnl[i] = callCumPnl[i - 1] + pnlDelta;
    }
    if (callCumPositions[callCumPositions.length - 1] != 0) {
        throw Error("Cannot have a non zero cumulative call position for a combo option");
    }
    let putCumPnl = Array(optionParams.length + 1).fill(0);
    let putCumPositions = Array(optionParams.length + 1).fill(0);
    putCumPositions[optionParams.length] = putSizes[optionParams.length];
    for (let i = optionParams.length - 1; i >= 0; i--) {
        let positionSize = i == 0 ? 0 : putSizes[i];
        putCumPositions[i] = positionSize + putCumPositions[i + 1];
        let strikeDiff = strikes[i + 1] - strikes[i];
        let pnlDelta = calculateSignedCostOfTrades(strikeDiff, putCumPositions[i + 1]);
        putCumPnl[i] = putCumPnl[i + 1] + pnlDelta;
    }
    if (putCumPositions[0] > 0) {
        throw Error("Cannot have a positive cumulative put position for a combo option");
    }
    let totalPositionPnl = Array(optionParams.length + 1).fill(0);
    for (let i = 0; i < optionParams.length + 1; i++) {
        totalPositionPnl[i] = callCumPnl[i] + putCumPnl[i];
        if (totalPositionPnl[i] > 0) {
            throw Error("Cannot have positive PnL at any strike when minting a combo option");
        }
    }
    let minPnl = Math.min(...totalPositionPnl);
    if (minPnl >= 0) {
        throw Error("Cannot mint a combo option with <= 0 collateral required");
    }
    return Math.abs(minPnl);
}
exports.getCollateralRequiredForComboOption = getCollateralRequiredForComboOption;
function calculateMintingFees(collateralAmount) {
    return Math.ceil((collateralAmount * flex_1.flex.state.mintOptionFee) /
        constants.MINT_OPTION_FEE_DENOMINATOR);
}
exports.calculateMintingFees = calculateMintingFees;
